<template>
  <div class="login-page">
    <div style="position: absolute; left:-9999px;"><input type="text"><input type="password"></div>
    <div class="login-page-header">
      <h1>{{ $t('Loginpages.title') }}</h1>
    </div>
    <div class="login-page-inner" v-if="signtype">
      <div class="login-page-left">
        <div class="login-page-left-inner">
          <LoginLeftComponent />
        </div>
      </div>
      <div class="login-page-right">
        <div class="login-form-box">
          <h1>{{ $t('Loginpages.formtitle') }}</h1>
          <div class="login-form-tips">
            <p v-if="chkemailerror">{{ logintips }}</p>
          </div>
          <el-input prefix-icon="iconfont icon-Email" v-model="email" :placeholder="$t('Loginpages.email')"></el-input>
          <div class="login-form-tips">
            <p v-if="chkepassworderror">Password</p>
          </div>
          <el-input prefix-icon="iconfont icon-yaochi" v-model="password" :placeholder="$t('Loginpages.passwd')" show-password></el-input>
          <el-button @click="onClickSignup">{{ $t('Loginpages.signup') }}</el-button>
          <p class="login-form-bottom-p">{{ $t('Loginpages.alreadyhaveaccount') }}? <router-link to="/Login">{{ $t('Loginpages.signin') }}</router-link></p>
          <p class="login-form-terms">{{ $t('Loginpages.t1') }}{{ $t('Loginpages.t2') }}{{ $t('Loginpages.t3') }}{{ $t('Loginpages.t4') }}</p>
        </div>
      </div>
    </div>
    <div class="login-page-inner signup-success-tips-box" v-if="signtypesuccess">
      <div class="forgetpassword-page-box">
        <h1>{{ $t('Loginpages.successful') }}</h1>
        <div class="forgetpassword-confirmed">
          <p>{{ $t('Loginpages.reginfo') }}</p>
          <router-link to="/Login">{{ $t('Loginpages.backto') }}</router-link>
        </div>
      </div>
    </div>
    <div class="footer-copy">©2018-2020 数聆（上海）数据科技有限公司.All rights reserved.<a href="http://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020181207084743000003442607-SAIC_SHOW_310000-2021110415483913206&signData=MEQCICGc0zlTD86t0dl7ZBOz/SiqBAMsToFxCev7t7AJHAayAiB8gKPb23/E7TQONWWrmejlMygrADhEQFhU4piCa5VoEA==" target="_blank"><img src="../assets/img/ico.jpg" /></a></div>
  </div>
</template>

<script>
import LoginLeftComponent from '../components/LoginLeftComponent.vue'
export default {
  components: {
    LoginLeftComponent
  },
  data(){
    return{
      signtype: true,
      signtypesuccess: false,
      email: '',
      password: '',
      chkemailerror: false,
      chkepassworderror: false,
      rememberme: false,
      logintips: ''
    }
  },
  methods: {
    onClickSignup: function(){
      console.log('Signup')
      let that = this;
      let url = 'http://dashboard.api.trade-intelligence.com/basic/user/registered';
      let dataRegister = {
        account: that.email,
        password: btoa(that.password),//Base64加密：btoa(str)；解密：atob(base64)
      };
      console.log(dataRegister)
      $.ajax(url, {
        type: "POST",
        data: JSON.stringify(dataRegister),
        contentType: "application/json",
        success: function(data) {
          if(data.code === 200){
            that.signtype = false
            that.signtypesuccess = true
            that.setLocalStorage('key', data.data.key)
            that.setLocalStorage('token', data.data.token)
          }else{
            that.logintips = data.error;
            that.chkemailerror = true
          }
          console.log(data)
        },
        error: function(response) {
          //that.dialogsiginup_error = true
          console.log(response)
        }
      })
    }
  },
}
</script>